import { Link } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { TELEGRAM_SUPPORT_URL, SUPPORT_EMAIL, WHATSAPP_SUPPORT_URL } from "@/config/site";

const LEGAL = [
  { to: "/terms", label: "Terms & Conditions" },
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/refund", label: "Refund Policy" },
  { to: "/aml", label: "AML & Financial Crime Policy" },
  { to: "/delivery", label: "Delivery Policy" },
];

export default function Footer() {
  const store = useStore();
  return (
    <footer className="mt-28 border-t border-white/[0.07]" data-testid="footer">
      <div className="vault-container grid grid-cols-2 gap-10 py-14 md:grid-cols-4">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="block h-3 w-3 rotate-45 rounded-[3px] bg-primary" />
            <span className="font-display text-sm font-semibold uppercase tracking-[0.35em]">Zeyinx</span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-muted-foreground">
            Digital gift cards and subscription vouchers, securely delivered by email.
          </p>
          <p className="mt-4 text-xs leading-relaxed text-muted-foreground">
            Enkrypt Enterprise<br />
            102, Kakkazham East, Ambalapuzha<br />
            Alappuzha, Kerala 688561, India
          </p>
          {store.ready && (
            <p className="mt-4 text-xs text-muted-foreground" data-testid="footer-region-echo">
              {store.marketObj ? `${store.marketObj.flag} ${store.marketObj.name}` : "🌐 No market selected"} · {store.currency}
            </p>
          )}
        </div>
        <div>
          <p className="overline-label mb-4">Shop</p>
          <ul className="flex flex-col gap-2.5 text-sm text-muted-foreground">
            <li><Link data-testid="footer-gift-cards" to="/cards" className="transition-colors duration-200 hover:text-foreground">Gift Cards</Link></li>
            <li><Link data-testid="footer-how-it-works" to="/how-it-works" className="transition-colors duration-200 hover:text-foreground">How It Works</Link></li>
            <li><Link data-testid="footer-support" to="/support" className="transition-colors duration-200 hover:text-foreground">Support</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline-label mb-4">Legal</p>
          <ul className="flex flex-col gap-2.5 text-sm text-muted-foreground">
            {LEGAL.map((l) => (
              <li key={l.to}>
                <Link data-testid={`footer-${l.to.slice(1)}`} to={l.to} className="transition-colors duration-200 hover:text-foreground">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="overline-label mb-4">Help</p>
          <ul className="flex flex-col gap-2.5 text-sm text-muted-foreground">
            <li><Link data-testid="footer-contact" to="/contact" className="transition-colors duration-200 hover:text-foreground">Contact</Link></li>
            <li><Link data-testid="footer-faq" to="/support" className="transition-colors duration-200 hover:text-foreground">Help / FAQ</Link></li>
            <li>
              {TELEGRAM_SUPPORT_URL ? (
                <a data-testid="footer-telegram" href={TELEGRAM_SUPPORT_URL} target="_blank" rel="noopener noreferrer" className="transition-colors duration-200 hover:text-foreground">Telegram Support</a>
              ) : (
                <span data-testid="footer-telegram" className="cursor-not-allowed text-muted-foreground/50">Telegram Support (coming soon)</span>
              )}
            </li>
            <li>
              {WHATSAPP_SUPPORT_URL ? (
                <a data-testid="footer-whatsapp" href={WHATSAPP_SUPPORT_URL} target="_blank" rel="noopener noreferrer" className="transition-colors duration-200 hover:text-foreground">WhatsApp Support</a>
              ) : (
                <span data-testid="footer-whatsapp" className="cursor-not-allowed text-muted-foreground/50">WhatsApp Support (coming soon)</span>
              )}
            </li>
            <li className="text-xs text-muted-foreground/70">{SUPPORT_EMAIL}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/[0.07]">
        <div className="vault-container flex flex-col gap-2 py-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 Enkrypt Enterprise · Zeyinx. All rights reserved.</span>
          <span>Digital delivery by email · After payment verification</span>
        </div>
      </div>
    </footer>
  );
}
